import { axiosInstance } from "api/axios-config/axios-config";
import {
  AddUser,
  GetUsers,
  UpdateUser,
} from "api/models/request/user-role/users";
import { Pagination } from "api/models/response/pagination";
import { IRoleProperties } from "mobx-stores/_models/user-roles/role";
import { IUserProperties } from "mobx-stores/_models/user-roles/user";

class UsersBusiness {
  readonly url = "/api/app/user";
  public getUsers = async (request: GetUsers) => {
    try {
      var res = await axiosInstance.get<Pagination<IUserProperties>>(this.url, {
        params: request,
      });
      return res.data;
    } catch (error) {
      console.error("Fail getUsers", error);
      return Promise.reject(error);
    }
  };

  public addUser = async (addUser: AddUser) => {
    try {
      var res = await axiosInstance.post<IUserProperties>(this.url, addUser);
      return res.data;
    } catch (error) {
      console.error("Fail addUser", error);
      return Promise.reject(error);
    }
  };

  public getUserById = async (id: string) => {
    try {
      var res = await axiosInstance.get<IUserProperties>(`${this.url}/${id}`);
      return res.data;
    } catch (error) {
      console.error("Fail getUserById", error);
      return Promise.reject(error);
    }
  };

  public updateUser = async (id: string, update: UpdateUser) => {
    try {
      var res = await axiosInstance.put<IUserProperties>(
        `${this.url}/${id}`,
        update
      );
      return res.data;
    } catch (error) {
      console.error("Fail updateUser", error);
      return Promise.reject(error);
    }
  };

  public deleteUser = async (userId: string) => {
    try {
      var res = await axiosInstance.delete(`${this.url}/${userId}`);
      return res.data;
    } catch (error) {
      console.error("Fail deleteUser", error);
      return Promise.reject(error);
    }
  };

  public getUserRoles = async (userId: string) => {
    try {
      var res = await axiosInstance.get<Pagination<IRoleProperties>>(
        `${this.url}/${userId}/roles`
      );
      return res.data;
    } catch (error) {
      console.error("Fail getUserRoles", error);
      return Promise.reject(error);
    }
  };

  public getAssignableRoles = async () => {
    try {
      var res = await axiosInstance.get<Pagination<IRoleProperties>>(
        `${this.url}/assignable-roles`
      );
      return res.data;
    } catch (error) {
      console.error("Fail getAssignableRoles", error);
      return Promise.reject(error);
    }
  };
}

export const usersBusiness = new UsersBusiness();
